/** @format */

import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../core/table";
import { getHeaderConfig } from "./config";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { toast } from "react-toastify";
import CustomModal from "../../core/modal";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
import PartFilters from "./part-filters";
const Parts = () => {
  const [addParts, setAddParts] = useState(false);
  const [description, setDescription] = useState("");
  const [parts, setParts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData();
    }
  }, []);
  const addPartFormHandler = () => {
    setAddParts(true);
  };
  const addDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };
  const payload = {
    type: "part",
    description: description,
  };
  //Show All Parts
  const loadData = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.List_CODES}`, null, {
      type: "part",
      ...filters,
    })
      .then((response) => {
        if (response) {
          setParts(response);
        }
      })
      .catch((err) => console.error(err));
  };
  //Add New Part
  const formSubmitHandler = () => {
    if (payload.code !== "" && payload.description !== "") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CODES}part`,
        payload,
        { active: true }
      )
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            loadData();
            setDescription("");
            setAddParts(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  return (
    <>
      <div className="page-body">
        <div className="create-con">
          <div>
            <p className="tab-name">Setup</p>
            <p className="section-name">Parts</p>
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            onClick={addPartFormHandler}
          >
            Add Part
          </CustomButtonComponent>
        </div>

        <div className="si-hide-mobile">
          <CustomTable
            header={getHeaderConfig(loadData)}
            data={parts || []}
            filterCom={<PartFilters loadData={loadData} parts={parts} />}
          />
        </div>
        {addParts && (
          <CustomModal title="New Part " onClose={() => setAddParts(false)}>
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                fullWidth
                id="description"
                label="Description"
                multiline
                sx={{ m: 1 }}
                rows={4}
                onChange={addDescriptionHandler}
                value={description}
              />
              <Stack
                direction="row"
                spacing={2}
                sx={{ m: 1, justifyContent: "flex-end" }}
              >
                <CustomButtonComponent
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={() => {
                    setAddParts(false);
                  }}
                >
                  Cancel
                </CustomButtonComponent>
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={formSubmitHandler}
                >
                  Save
                </CustomButtonComponent>
              </Stack>
            </Box>
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default Parts;
